// Registers global shortcuts by scanning sidebar links (and buttons, which get
// clicked) with [data-shortcut-key] attributes. This keeps the sidebar as the single
// source of truth — shortcuts only exist for nav items actually on the page.
//
// Mount this on the same element as the keyboard-shortcut-registry controller.

import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  connect() {
    this.registeredKeys = []
    this.scanAndRegister()
  }

  disconnect() {
    this.deregisterAll()
  }

  // Private

  scanAndRegister() {
    document.querySelectorAll("[data-shortcut-key]").forEach((el) => {
      const key = el.dataset.shortcutKey
      const url = el.getAttribute("href")
      const isExternal = el.dataset.external === "true"
      const description = `${isExternal ? "Open" : "Go to"} ${el.textContent.trim()}`

      if (el.tagName === "BUTTON") {
        if (key) this.register(key, el.textContent.trim(), "Actions", () => el.click())
        return
      }

      if (!key || !url) return

      this.register(key, description, "Navigation", () => {
        if (isExternal) {
          window.open(url, "_blank", "noopener")
        } else {
          Turbo.visit(url)
        }
      })
    })
  }

  deregisterAll() {
    this.registeredKeys.forEach((key) => {
      this.element.dispatchEvent(
        new CustomEvent("shortcut:deregister", { detail: { key }, bubbles: true })
      )
    })
    this.registeredKeys = []
  }

  register(key, description, category, handler) {
    this.registeredKeys.push(key)
    this.element.dispatchEvent(
      new CustomEvent("shortcut:register", {
        detail: { key, description, category, handler },
        bubbles: true,
      })
    )
  }
}
